import { mapStowagePlan } from './StowagePlanFactory';

export const filterAndMapOfflineStowagePlans = (offlineStowagePlans: any[], imoNumber: number) => {
    return offlineStowagePlans?.length
        ? offlineStowagePlans
              .filter((s) => +s.imoNumber === +imoNumber && (s.addStowagePlanRequest || s.updateStowagePlanRequest))
              .map((item) => mapStowagePlan({ ...item.addStowagePlanRequest?.body, ...item.updateStowagePlanRequest?.body }))
        : [];
};
